// extracted by mini-css-extract-plugin
export var addButton = "_fd-0";
export var border = "_fd-8";
export var check = "_fd-h";
export var danger = "_fd-6";
export var dropdownContainer = "_fd-1";
export var editModalBody = "_fd-j";
export var footerContainer = "_fd-i";
export var fullWidth = "_fd-a";
export var hide = "_fd-9";
export var icon = "_fd-3";
export var input = "_fd-7";
export var inputFlex = "_fd-b";
export var inputWrapper = "_fd-c";
export var manualFocus = "_fd-5";
export var optionButton = "_fd-4";
export var pillWrapper = "_fd-e";
export var pointer = "_fd-2";
export var showOverflow = "_fd-f";
export var tagsFlex = "_fd-d";
export var xButton = "_fd-g";